import { MenuGroup } from '../../../../../../components/blackrock/advisor-center/_types/navigation';

/**
 * SiteMapMenuGroup Component
 * Displays the MenuGroups
 */
const SiteMapMenuGroup: React.FC<{
	menuGroup: MenuGroup;
}> = ({ menuGroup }) => {
	return (
		<li className="site-map-menu-group-container">
			<div className="menu-group-header" role="heading" aria-level={5}>
				{menuGroup.name}
			</div>
			<ul className="menu-item-container" aria-label={menuGroup.name}>
				{/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore */}
				{menuGroup.menuItems.map((menuItem) => (
					<li key={menuItem.displayValue}>
						<a
							href={menuItem.href}
							data-link-event={menuItem.dataLinkEvent}
							aria-label={menuItem.ariaLabel}
							target={menuItem.target ?? undefined}
							className={`menu-item ${menuItem.additionalStyleClass || ''}`}
							data-final-url
							dangerouslySetInnerHTML={{ __html: menuItem.displayValue || '' }}
						></a>
					</li>
				))}
			</ul>
		</li>
	);
};

export default SiteMapMenuGroup;
